// @ts-nocheck
import { PageBlockTypes as p } from '@xprog/prensa/types'

import { teasers as T } from '../../../opopular/assets/teasers'

export const LayoutColumnistSideBox: p.SlotConfigProps = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnContent': {
        pt: '$6',
        pb: '$6',
        maxWidth: 'calc(100% - $2)'
      },
    }
  },
  slotConfig: {
    TemplateSideBoxColumnist: {
      slotLeft: {
        default: [T.TeaserColumnist, T.TeaserColumnist]
      }
    }
  }
}